import NoImage from '../../NoImage.png';

export function getActivityPhoto(activity) {
  return activity.pictures?.length > 0 ? activity.pictures[0].url : NoImage;
}

const MAX_HOURS_LENGTH = 40;

export const truncateHoursString = hours => {
  const ellipsis = hours?.length > MAX_HOURS_LENGTH ? '...' : '';
  return `${hours?.substr(0, MAX_HOURS_LENGTH - 1)}${ellipsis}`;
};

export const mimeTypeToIconMap = {
  'application/pdf': 'fa-file-pdf-o',
  default: 'fa-file-o',
};

export const isAttendeesRequired = (
  attendeesMinimum?: number,
  attendeesMaximum?: number | null
): boolean => {
  let min = attendeesMinimum;
  if ((min || 0) < 1) min = 1;

  let max = attendeesMaximum;
  if (max === 0 || max === undefined) max = null;

  return min !== 1 || max !== null;
};
